import { UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from "@angular/forms";

export interface FormConfigEntryType {
  id: string;
  type: string;
  core?: boolean;
  required?: boolean;
  // validators?: Array<ValidatorFn>;
}

export interface FormModelControlType {
  control: UntypedFormControl;
  type: string;
  value: any;
}

export type ControlListType = { [key: string]: FormModelControlType };

export class FormModelModel {

  public form: UntypedFormGroup;
  public model: any;
  public controls: ControlListType = {};

  constructor(model: any) {
    this.model = model;
    this.form = new UntypedFormGroup({});
  }

  public initForm(config: Array<FormConfigEntryType>, data: { [key: string]: any }): ControlListType {
    if (Array.isArray(config)) {
      config.forEach((entry: FormConfigEntryType) => {
        let value = '';
        if (data && data.hasOwnProperty(entry.id)) {
          value = data[entry.id];
        }
        const validators = [];
        if (entry.required) {
          validators.push(Validators.required);
        }
        const control = new UntypedFormControl(value, validators);
        control.disable();
        this.form.addControl(entry.id, control);
        this.controls[entry.id] = {
          control,
          value,
          type: entry.type,
        };
      });
    }
    return this.controls;
  }

  public getControlValue(name: string): any {
    return this.controls[name].control.value;
  }

  public getPayload(): any | null {
    return null;
  }

}
